















































































































// Vue
import { Component, Vue } from 'vue-property-decorator'

// vuex
import { namespace } from 'vuex-class'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

// utils
import { alerts } from '@/utils'

// models
import { AuthResponse, AuthLogin } from '@/models'

// components
import { Loading } from '@/components'
import { Form, Input, CheckBox } from '@/components/form'

const auth = namespace('auth')

@Component({
  name: 'Login',
  components: {
    Form,
    Input,
    CheckBox,
    Loading
  },
  mixins: [validationMixin]
})

export default class Login extends Vue {
  hasError = false
  isLoading = false
  form = {
    email: '',
    password: '',
    remember: false
  };

  @auth.Action
  public login !: (form: AuthLogin) => AuthResponse

  @Validations()
  validations () {
    return {
      form: {
        email: { required, minLength: minLength(4), email },
        password: { required, minLength: minLength(4) }
      }
    }
  }

  created () {
    document.body.classList.add('auth-body-bg')
  }

  destroyed () {
    document.body.classList.remove('auth-body-bg')
  }

  async loginAuth () {
    this.$v.$touch()
    if (!this.$v.$anyError) {
      this.isLoading = true
      const res = await this.login(this.form)
      if (res.success) {
        alerts.success(res.msg)
        return location.reload()
      } else {
        alerts.error(res.msg)
      }
      this.isLoading = false
    } else {
      alerts.error()
    }
  }
}
